// eslint-disable-next-line import/no-extraneous-dependencies
import { Ref } from '@stardust-ui/react-component-ref';

export default Ref;
